import Calendar from './Calendar.vue';

export * from './components';
export * from './types';
export default Calendar;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/index.ts